


















































import { defineComponent, onMounted, reactive, ref } from '@vue/composition-api';
import OlbInput from '../elements/input/Input.vue';
import OlbButton from '../../button';
import OlbLoader from '../../loader';
import { ValidationObserver } from 'vee-validate';
import axios, { Method } from 'axios';

interface Result {
	issuerName: string;
	wkn: string;
	isin: string;
	entries: {
		url: string;
		title: string;
		documentDate: string;
		documentType: string;
		documentSize: string;
	}[];
}

export default defineComponent({
	components: {
		OlbInput,
		OlbButton,
		OlbLoader,
		ValidationObserver,
	},
	props: {
		action: {
			type: String,
		},
		method: {
			type: String,
		},
		title: {
			type: String,
		},
		text: {
			type: String,
		},
		label: {
			type: String,
		},
		id: {
			type: String,
		},
		placeholder: {
			type: String,
		},
		name: {
			type: String,
		},
		buttonText: {
			type: String,
		},
		resultsText: {
			type: String,
		},
		noResultsText: {
			type: String,
		},
	},
	setup(props) {
		const observer = ref();
		const state = reactive<{ input: string; res: Result | null; loading: boolean; error: string | null }>({
			input: '',
			res: null,
			loading: false,
			error: null,
		});

		async function onSubmit(e: Event) {
			e.preventDefault();
			const valid = await observer.value.validate();
			if (valid) {
				state.loading = true;
				axios({
					method: (props.method as Method) || 'GET',
					url: `${props.action}?q=${state.input}&type=${props.name || 'wai'}`,
				})
					.then((data) => data.data)
					.then((res: Result) => {
						state.res = res;
						state.loading = false;
					})
					.catch((error) => {
						state.error = error;
						state.loading = false;
					});
			}
		}

		return {
			state,
			observer,
			onSubmit,
		};
	},
});
